import React from "react";
import { Panel } from "../../components/ui/dashboard";

const TrackShipment: React.FC = () => {
  return (
    <div className="p-4 md:p-6 space-y-4">
      <Panel title="Track Shipment" subtitle="Search by LR number">
        <div className="flex gap-2">
          <input className="border rounded-lg px-3 py-2 text-sm flex-1" placeholder="Enter LR Number (e.g. TT-2026-00142)" />
          <button className="px-3 py-2 text-sm rounded-lg bg-indigo-600 text-white">Track</button>
        </div>
      </Panel>
      <Panel title="Route Map" subtitle="Latest location and movement">
        <div className="h-56 rounded-xl border border-slate-100 bg-gradient-to-br from-slate-100 via-cyan-50 to-slate-200 flex items-center justify-center text-slate-500 text-sm">
          Map placeholder with current consignment pin
        </div>
      </Panel>
    </div>
  );
};

export default TrackShipment;